import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddCountyPage = React.lazy(() => import(/* webpackChunkName: "AdminAddCounty" */ './Page'));
export const AdminAddCounty = () => (React.createElement(Page, { title: "Administrator Add County" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddCountyPage, null)))));
